import React from 'react';
import PropTypes from 'prop-types';
import styles from './ErrorPage.module.css';
import commonStrings from 'resources/commonStrings';
import TaglineSVG from './images/nweaTagline.svg';

const TaglineImage = () => <div className={styles['tagline']}>{<TaglineSVG />}</div>;
const propTypes = {
  thrownError: PropTypes.shape().isRequired,
};

function ErrorPage({ thrownError }) {
  let errType = 1800;

  if (thrownError.code) {
    errType = thrownError.code;
  }

  const { header, description, helpList } =
    errType !== 1800
      ? commonStrings.errors[errType]
      : Object.assign(commonStrings.errors[errType], { description: thrownError.message });

  const helpListItems = helpList.map((element, index) => {
    return (
      <li key={index} className={styles['help-item']}>
        {element}
      </li>
    );
  });

  return (
    <main className={styles['error-box']}>
      <figure className={styles['header']}>
        <TaglineImage />
      </figure>
      <section className={styles['error-content']}>
        <h1 data-testid="error-page-header" className={styles['error-header']}>
          {header}
        </h1>
        <p className={styles['error-description']}>{description}</p>
        <p>Please try the following:</p>
        <ol className={styles['error-help-list']}>{helpListItems}</ol>
        <br />
      </section>
    </main>
  );
}

ErrorPage.propTypes = propTypes;

export default ErrorPage;
